import React, { useState } from 'react';
import i18n from 'i18n';
import { Col, Form, Row, Tab, Tabs } from 'react-bootstrap';
import { messageSourceTypes, RecordingMessage } from '../../../../types/rest/assetCatalogTypes';
import { title } from '../../Transactions/TransactionEditor/RequestTab/RequestTab';
import BlazeTable from '../../../../components/blazeTable/BlazeTable';
import { BlazeTableColDef } from '../../../../components/blazeTable/BlazeTable.types';
import {
  getColsTableDefinition,
  responseTblOpts,
} from '../../../../components/transactionsShuttle/transactionsSimpleTable/details/HttpTransactionSimpleTabs';
import { messagePropertyTypes, messageTypes } from '../../../../types/rest/dslTypes';
import { ResponseKeyValueItem } from '../../../../components/transactionEditor/ResponseKeyValueList';

interface RecordingMessageReadOnlyProps {
  recordingMessage: RecordingMessage;
}

const propertiesColsDefinition: BlazeTableColDef[] = [
  {
    header: i18n.t('recordings:editor.matcherName'),
    accessor: 'name',
  },
  {
    header: i18n.t('recordings:editor.value'),
    accessor: 'value',
  },
  {
    header: i18n.t('recordings:editor.type'),
    cellComponent: (item: ResponseKeyValueItem) => {
      return <span>{messagePropertyTypes[item.type]}</span>;
    },
    accessor: 'type',
  },
];

const propertiesTblOpts = getColsTableDefinition(
  propertiesColsDefinition,
  i18n.t('recordings:editor.emptyPropertiesListMessage'),
);

const RecordingMessageSimpleView = ({ recordingMessage }: RecordingMessageReadOnlyProps) => {
  const [selectedTab, setSelectedTab] = useState('body-tab');
  return (
    <div className="card">
      <div className="card-body">
        <Col md={9}>
          <Row>
            <Col md={2}>
              <Form.Label>{i18n.t('recordings:table.name')}:</Form.Label>
            </Col>
            <Col>
              <span>{recordingMessage.name}</span>
            </Col>
          </Row>
          <Row>
            <Col md={2}>
              <Form.Label>{i18n.t('recordings:editor.messages.messageType')}:</Form.Label>
            </Col>
            <Col>
              <span>{messageTypes[recordingMessage.messageType]}</span>
            </Col>
          </Row>
          <Row>
            <Col md={2}>
              <Form.Label>{i18n.t('recordings:editor.delay')}:</Form.Label>
            </Col>
            <Col>
              <span>{recordingMessage.delay}</span>
            </Col>
          </Row>
          <Row>
            <Col md={2}>
              <Form.Label>{i18n.t('recordings:editor.messages.destinationName')}:</Form.Label>
            </Col>
            <Col>
              <span>{recordingMessage.destination}</span>
            </Col>
          </Row>

          <Row>
            <Col md={2}>
              <Form.Label>{i18n.t('recordings:editor.messages.destinationType')}:</Form.Label>
            </Col>
            <Col>
              <span>{messageSourceTypes[recordingMessage.destinationType]}</span>
            </Col>
          </Row>
        </Col>
        <div className="bg-light p-4">
          <Tabs id="qa-tabs-definitions" activeKey={selectedTab} onSelect={(key: string) => setSelectedTab(key)}>
            <Tab title={i18n.t('recordings:editor.bodyTitle')} eventKey="body-tab" style={{ marginTop: '-10px' }}>
              <Form.Control as="textarea" rows={5} name="content" value={recordingMessage.content} readOnly={true} />
            </Tab>
            <Tab
              title={title('Headers', recordingMessage.headers ? recordingMessage.headers.length : 0)}
              eventKey="headers-tab"
            >
              <BlazeTable options={responseTblOpts} data={recordingMessage.headers} />
            </Tab>
            <Tab
              title={title('Properties', recordingMessage.properties ? recordingMessage.properties.length : 0)}
              eventKey="properties-tab"
            >
              <BlazeTable options={propertiesTblOpts} data={recordingMessage.properties} />
            </Tab>
          </Tabs>
        </div>
      </div>
    </div>
  );
};

export default RecordingMessageSimpleView;
